export default __webpack_public_path__ + "Assets/PREMIUM/baden_wuerttemberg/Uebersicht_ProFit_Erwachsene.pdf";